// Page do detalhe do envio do notification-center (rota
// /notification-center/notifications/:notificationUuid). O detalhe
// era um drawer na Consulta; virou página dedicada para dar espaço
// à timeline, aos cartões e às abas (Detalhes / Template enviado).
import { useTranslation } from "react-i18next"
import { useParams } from "react-router-dom"

import { AppBreadcrumb } from "@/components/layout/app-breadcrumb"
import { Header } from "@/components/layout/header"
import { FRONTEND_ROUTES } from "@/constants"
import { NotificationDetail } from "@/features/notification-center"

export function NotificationDetailsPage() {
  const { t } = useTranslation()
  const { notificationUuid } = useParams<{
    notificationUuid: string
  }>()

  return (
    <main className="flex w-full flex-1 flex-col">
      <Header>
        <AppBreadcrumb
          links={[
            {
              href: FRONTEND_ROUTES.DASHBOARD.href,
              label: t("sidebar.dashboard"),
            },
            {
              href: FRONTEND_ROUTES.NOTIFICATION_CENTER
                .href,
              label: t("pages.notificationCenter.title"),
            },
            {
              href: FRONTEND_ROUTES
                .NOTIFICATION_CENTER_SEARCH.href,
              label: t(
                "pages.notificationCenter.searchPage.title"
              ),
            },
            {
              label: t(
                "pages.notificationCenter.notificationDetailPage.breadcrumb"
              ),
            },
          ]}
        />
      </Header>
      <section className="flex flex-1 flex-col gap-4 p-4 @container">
        <NotificationDetail uuid={notificationUuid ?? ""} />
      </section>
    </main>
  )
}
